import { useContentSelector } from '@wajeez-web/stores/content';

export const useGetComponentTypeByIdMultilingual = () => {
  return useContentSelector(
    ({ componentTypes }) => componentTypes.componentTypeByIdMultilingual
  );
};

export const useCreateComponentTypeMultilingual = () => {
  return useContentSelector(
    ({ componentTypes }) => componentTypes.createComponentTypeMultilingual
  );
};

export const useEditComponentTypeMultilingual = () => {
  return useContentSelector(
    ({ componentTypes }) => componentTypes.editComponentTypeMultilingual
  );
};
